
function SdInputAvatarsController(TranslationService, UserSettingService) {
    var ctrl = this;

    ctrl.searchUsers = function (query) {
        return UserSettingService.getUsersQuery(query)
            .then(function (response) {
                var resp = response.data.map(function (item) {
                    return {
                        UserID: item.Key,
                        text: item.Key, //componente obriga
                    };
                });
                ctrl.users = resp;
                return resp;
            })
            .catch(function (err) {
                console.error(err);
            });
    };

    ctrl.$onInit = function () {
        ctrl.width = 100;
        ctrl.searchUsers('');
    };

    ctrl.findUser = function (users, userID) {
        return users.findIndex(function (user) {
            return user.UserID == userID;
        });
    };

    ctrl.selectUser = function (user) {
        var index = ctrl.findUser(ctrl.ngModel, user.UserID);
        if (index >= 0) {
            ctrl.ngModel.splice(index, 1);
        }
        else {
            var newUser = {
                UserID: user.UserID
            }
            ctrl.ngModel.push(newUser);
        }
        //ctrl.applyStages(approval);
    };

    ctrl.isUserSelected = function (option) {
        if (!ctrl.ngModel) {
            return false;
        }
        var find = ctrl.ngModel.find(function (u) {
            return u.UserID == option.UserID;
        });
        return find;
    };
    
}

SdInputAvatarsController.$inject = ['TranslationService', 'UserSettingService'];

seedWebApp.component('sdInputAvatars', {
    controller: SdInputAvatarsController,
    controllerAs: 'ctrl',
    bindings: {
        ngModel: '<',
        users: '<',        
    },
    templateUrl: './SPA/components/sd-input-avatars.html'
});